<template>
  <v-autocomplete
    v-model="selectedValue"
    :items="formattedItems"
    :loading="loading"
    :search-input.sync="search"
    :filter="customFilter"
    item-value="id_pago_forma"
    item-text="displayText"
    label="Seleccionar Forma de Pago"
    placeholder="Buscar por nombre..."
    clearable
    no-data-text="No se encontraron resultados"
    @change="handleChange"
    outlined
    dense
    hide-details
  >
    <template v-slot:selection="{ item }">
      <span>
        <strong>{{ item.nombre }}</strong> - {{ item.nombre_titular_cuenta }}
      </span>
    </template>
    
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title>
          <strong>{{ item.nombre }}</strong> - {{ item.nombre_titular_cuenta }}
        </v-list-item-title>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: 'GastoSubtipoAutocomplete',
  
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: null
    }
  },
  
  data() {
    return {
      selectedValue: this.value,
      search: null
    }
  },
  
  computed: {
    formattedItems() {
      return this.items.map(item => ({
        ...item,
        displayText: `${item.nombre_gasto_tipo} - ${item.nombre}`
      }))
    }
  },
  
  watch: {
    value(newVal) {
      this.selectedValue = newVal
    }
  },
  
  methods: {
    handleChange(value) {
      this.$emit('input', value)
      this.$emit('change', value)
    },
    
    // Filtro personalizado insensible a mayúsculas, minúsculas y acentos
    customFilter(item, queryText) {
      if (!queryText) return true
      
      const normalize = (text) => {
        return text
          .toString()
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
      }
      
      const normalizedQuery = normalize(queryText)
      const normalizedTipo = normalize(item.nombre_gasto_tipo || '')
      const normalizedNombre = normalize(item.nombre || '')
      
      return normalizedTipo.includes(normalizedQuery) || 
             normalizedNombre.includes(normalizedQuery)
    }
  }
}
</script>

<style scoped>
/* Estilos opcionales personalizados */
</style>